import React, { useCallback } from 'react'
import { Modal } from '@app/src/common/Modal';
import { ModalWrapper, ErrorText } from './styled';
import { useSelector, useDispatch } from 'react-redux'
import { actionsModalError } from '@app/src/common/modalError';
import { isClientEnv } from '@app/src/utils/validations';

const isClient = isClientEnv();

interface Props {
  errorChange?: Function;
}

export const ModalError: React.FC<Props> = ({ errorChange }) => {
  const dispatch = useDispatch();
  const display = useSelector(state => state.modalError.show);
  const message = useSelector(state => state.modalError.message);
  const redirect = useSelector(state => state.modalError.href);

  const handleClickClose = useCallback(() => {
    errorChange && errorChange();
    if(isClient) {
      
      if (redirect) {
        window.location.href = redirect;
      } else {
        window.location.reload();
      }
      dispatch(actionsModalError.closeModalError());
    }
  }, [redirect, dispatch, message])

  return (
    <Modal show={display} closeModal={handleClickClose}>
        <ModalWrapper>
            {
                message
                ? <ErrorText>{message}</ErrorText>
                : <ErrorText>Ocurrió un Error</ErrorText>
            }
        </ModalWrapper>
    </Modal>
)}
